<template>
  <b-card no-body>
    <b-card-header :class="{ 'pb-0': !padding, 'pb-1': padding }">
      <!-- title and subtitle -->
      <div>
        <b-card-title class="font-weight-bolder mb-1">
          {{ dataCart.title }}
        </b-card-title>
        <b-card-sub-title>
          {{ dataCart.subTitle }}
        </b-card-sub-title>
      </div>
    </b-card-header>

    <b-card-body>
      <!-- <b-button-group size="sm">
        <b-button
          :class="seriActive==='today'?'active':''"
          variant="outline-primary"
          @click="actionFilter('today')"
        >
          Yesterday
        </b-button>
        <b-button
          :class="seriActive==='last7days'?'active':''"
          variant="outline-primary"
          @click="actionFilter('last7days')"
        >
          Last 7 Days
        </b-button>
        <b-button
          :class="seriActive==='thismonth'?'active':''"
          variant="outline-primary"
          @click="actionFilter('thismonth')"
        >
          This Month
        </b-button>
      </b-button-group> -->
      <vue-apex-charts
        ref="apexMap"
        type="heatmap"
        height="300"
        :options="dTrafficPerform.options"
        :series="dTrafficPerform.series"
      />
      <div class="position-absolute w-100 legend">
        <div class="d-flex justify-content-center">
          <div class="color-indicator color-11" />
          <div class="color-indicator color-22" />
          <div class="color-indicator color-33" />
          <div class="color-indicator color-44" />
          <div class="color-indicator color-55" />
          <div class="color-indicator color-66" />
        </div>
        <div class="legend d-flex justify-content-center">
          <div class="text-indicator">
            0
          </div>
          <div class="text-indicator">
            5
          </div>
          <div class="text-indicator">
            50
          </div>
          <div class="text-indicator">
            100
          </div>
          <div class="text-indicator">
            500
          </div>
          <div class="text-indicator">
            1000
          </div>
          <div class="text-indicator">
            >1000
          </div>
        </div>
      </div>
    </b-card-body>
  </b-card>
</template>

<script>
import {
  BCard,
  BCardHeader,
  BCardBody,
  BCardSubTitle,
  BCardTitle,
  // BButtonGroup,
  // BButton,
} from 'bootstrap-vue'
import VueApexCharts from 'vue-apexcharts'
import { mapActions } from 'vuex'
// import flatPickr from 'vue-flatpickr-component'
// import apexChatData from './apexChartData'

export default {
  components: {
    VueApexCharts,
    BCard,
    BCardHeader,
    // flatPickr,
    // BButtonGroup,
    // BButton,
    BCardBody,
    BCardSubTitle,
    BCardTitle,
  },
  props: {
    // eslint-disable-next-line vue/require-default-prop
    dataCart: Object,
    // horizontal: Boolean,
    // eslint-disable-next-line vue/require-default-prop
    title: String,
    // eslint-disable-next-line vue/require-default-prop
    subTitle: String,
    padding: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      seriActive: 'today',
      dTrafficPerform: {
        series: [],
        options: {
          chart: {
            height: '300px',
            toolbar: {
              show: false,
            },
          },
          colors: ['#FFFFFF'],
          plotOptions: {
            heatmap: {
              enableShades: true,
              // shadeIntensity: 0.9,
              colorScale: {
                inverse: false,
                ranges: [
                  {
                    from: 0,
                    to: 5,
                    name: '1-5',
                    color: '#f2eae7',
                  },
                  {
                    from: 6,
                    to: 50,
                    name: '6-20',
                    color: '#f2d1c1',
                  },
                  {
                    from: 51,
                    to: 100,
                    name: '21-50',
                    color: '#F2B89B',
                  },
                  {
                    from: 101,
                    to: 500,
                    name: '51-100',
                    color: '#ED986E',
                  },
                  {
                    from: 501,
                    to: 1000,
                    name: '100-300',
                    color: '#E77841',
                  },
                  {
                    from: 1001,
                    to: 100000,
                    name: '301-600',
                    color: '#d34b08',
                  },
                ],
              },
              //   inverse: true,
            },
          },
          legend: {
            show: false,
            position: 'bottom',
          },
          grid: {
            xaxis: {
              lines: {
                show: true,
              },
            },
            yaxis: {
              lines: {
                show: true,
              },
              //   type: 'category',
            },
          },
          dataLabels: {
            enabled: false,
          },
          xaxis: {
            labels: {
              // minHeight: 220,
              style: {
                cssClass: 'text-left',
                // fontSize: '7px',
              },
            },
          },
          yaxis: {},
          states: {
            hover: {
              filter: {
                type: 'darken',
                value: 0.35,
              },
            },
          },
          tooltip: {
            theme: 'dark',
            fillSeriesColor: false,
            // shared: true,
            x: {
              show: true,
            },
            y: {},
          },
        },
      },
    }
  },
  beforeMount() {
    this.actionFilter('today')
  },
  methods: {
    ...mapActions('dashboard', ['getMostPurchase']),
    setData(data = null) {
      this.dTrafficPerform.series = data !== null ? this.dataCart.data : data
      // this.dTrafficPerform.series = data
    },
    setColor() {
      this.dTrafficPerform.options.colors = this.dataCart.color
    },
    actionFilter(type) {
      this.seriActive = type
      this.getMostPurchase(type).then(res => {
        this.setData(res)
        this.setColor()
        this.$refs.apexMap.updateOptions(this.dTrafficPerform.options)
        this.$refs.apexMap.updateSeries(this.dTrafficPerform.series)
      })
    },
  },
}
</script>

<style scoped>
.legend {
  bottom: 0.5rem;
  left: 0;
  padding-left: 0rem;
}
.color-indicator {
  padding: 0.5rem;
  width: 14%;
}
.color-11 {
  background-color: #f2eae7;
}
.color-22 {
  background-color: #f2d1c1;
}
.color-33 {
  background-color: #F2B89B;
}
.color-44 {
  background-color: #ED986E;
}
.color-55 {
  background-color: #E77841;
}
.color-66 {
  background-color: #d34b08;
}
.text-indicator {
  width: 14%;
  text-align: center;
  font-size: 0.8rem;
}
</style>
